import { EMPTY_SKILL_SELECT, FETCH_SKILL_SELECT, FETCH_SKILL_SELECT_SUCCESS } from "../ActionTypes";



// To fetch all skill set without pagination
export const fetchSkillSelect = () => ({
    type: FETCH_SKILL_SELECT
});

export const fetchSkillSelectSuccess = (payload) => ({
    type: FETCH_SKILL_SELECT_SUCCESS,
    payload
});

export const emptySkillSelect = () =>({
    type: EMPTY_SKILL_SELECT
});
